import React from "react";
import CustomTabs from "components/Shared/CustomTabs";
import { useGetNotesBySourceQuery } from "store/services/noteApi";
import { useSmsTemplateDetailContext } from "contexts/SmsTemplateDetailContext";
import { useSearchParams } from "react-router-dom";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import NoteTab from "../../Note/Notetab";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";

const SmsTemplateDetailTab = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "notes";

  const { smsTemplateDetail } = useSmsTemplateDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: "SmsTemplate",
      sourceRef: smsTemplateDetail?._id,
    },
    { skip: !smsTemplateDetail?._id }
  );

  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "SmsTemplate", sourceRef: smsTemplateDetail?._id },
    { skip: !smsTemplateDetail?._id }
  );

  const tabs = [
    {
      label: "Notes",
      value: "notes",
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {smsTemplateDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="notes">
            <NoteTab
              source="SmsTemplate"
              sourceRef={smsTemplateDetail._id}
            />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab
              source="SmsTemplate"
              sourceRef={smsTemplateDetail._id}
            />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default SmsTemplateDetailTab;